import { exeRequest } from '../utils/APIUtils';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  // Liste tous les paramètres (avec filtrage optionnel par catégorie et ville)
  getAll: async (category = null, city = null) => {
    const params = new URLSearchParams();
    if (category) params.append('category', category);
    if (city) params.append('city', city);
    const qs = params.toString();
    const url = qs ? `/admin/settings?${qs}` : '/admin/settings';
    return exeRequest(url, 'GET');
  },

  // Récupère un paramètre par sa clé
  getByKey: async (key) => exeRequest(`/admin/settings/${key}`, 'GET'),

  // Met à jour un paramètre (avec support ville optionnel)
  update: async (key, value, reason = '', city = null) => {
    const body = { value, reason };
    if (city) body.city = city;
    return exeRequest(`/admin/settings/${key}`, 'PUT', body);
  },

  // Crée un nouveau paramètre
  create: async (data) => exeRequest('/admin/settings', 'POST', data),

  // Récupère l'historique d'un paramètre (avec filtrage optionnel par ville)
  getHistory: async (key, limit = 50, offset = 0, city = null) => {
    const params = new URLSearchParams({ limit, offset });
    if (city) params.append('city', city);
    return exeRequest(`/admin/settings/${key}/history?${params.toString()}`, 'GET');
  },

  // Liste les catégories
  getCategories: async () => exeRequest('/admin/settings/categories', 'GET'),

  // Initialise les paramètres par défaut
  seed: async () => exeRequest('/admin/settings/seed', 'POST'),

  // Stats du cache
  getCacheStats: async () => exeRequest('/admin/settings/cache/stats', 'GET'),

  // Rafraîchir le cache
  refreshCache: async () => exeRequest('/admin/settings/cache/refresh', 'POST'),

  // Activer/Désactiver un paramètre
  toggle: async (key, isEnabled, reason = '') =>
    exeRequest(`/admin/settings/${key}/toggle`, 'PATCH', { isEnabled, reason }),

  // Supprimer un override ville
  removeCityOverride: async (key, cityCode, reason = '') =>
    exeRequest(`/admin/settings/${key}/city-override/${cityCode}`, 'DELETE', { reason }),
};
